interface FileViewProps {
    title: string,
    file: string,
    fileName?: string,
}

export default function FileView({title, file, fileName=""}: FileViewProps) {
    return (
        <>
            <div className="flex items-center space-x-3">
                <div className="bg-gray-200 border border-gray-800 p-2 rounded-md">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                        <path d="M6.76745 15.4646H5.80078V13.5312H6.76745C7.02382 13.5312 7.2697 13.6331 7.45098 13.8144C7.63227 13.9957 7.73411 14.2415 7.73411 14.4979C7.73411 14.7543 7.63227 15.0002 7.45098 15.1815C7.2697 15.3627 7.02382 15.4646 6.76745 15.4646ZM13.5341 19.3313V13.5312H14.5008C14.7572 13.5312 15.003 13.6331 15.1843 13.8144C15.3656 13.9957 15.4674 14.2415 15.4674 14.4979V18.3646C15.4674 18.621 15.3656 18.8668 15.1843 19.0481C15.003 19.2294 14.7572 19.3313 14.5008 19.3313H13.5341Z" fill="#432101" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.93359 2.9C1.93359 2.13087 2.23913 1.39325 2.78298 0.84939C3.32684 0.305535 4.06447 0 4.83359 0L20.7005 0L27.0669 6.36647V26.1C27.0669 26.8691 26.7614 27.6068 26.2175 28.1506C25.6737 28.6945 24.9361 29 24.1669 29H4.83359C4.06447 29 3.32684 28.6945 2.78298 28.1506C2.23913 27.6068 1.93359 26.8691 1.93359 26.1V2.9ZM6.76693 11.6H3.86693V21.2667H5.80026V17.4H6.76693C7.53605 17.4 8.27368 17.0945 8.81754 16.5506C9.36139 16.0068 9.66693 15.2691 9.66693 14.5C9.66693 13.7309 9.36139 12.9932 8.81754 12.4494C8.27368 11.9055 7.53605 11.6 6.76693 11.6ZM14.5003 11.6H11.6003V21.2667H14.5003C15.2694 21.2667 16.007 20.9611 16.5509 20.4173C17.0947 19.8734 17.4003 19.1358 17.4003 18.3667V14.5C17.4003 13.7309 17.0947 12.9932 16.5509 12.4494C16.007 11.9055 15.2694 11.6 14.5003 11.6ZM19.3336 21.2667V11.6H25.1336V13.5333H21.2669V15.4667H23.2003V17.4H21.2669V21.2667H19.3336Z" fill="#432101" />
                    </svg>
                </div>
                <div>
                    <p className="text-gray-800 font-medium">{title}</p>
                </div>
            </div>
            <a
                href={file}
                target="_blank"
                className="ml-auto my-auto text-blue-600 text-sm font-medium"
            >
                view
            </a>
        </>
    );
}

